import { render, staticRenderFns } from "./TalkSearchRecord.vue?vue&type=template&id=cdce23f0&scoped=true&"
import script from "./TalkSearchRecord.vue?vue&type=script&lang=js&"
export * from "./TalkSearchRecord.vue?vue&type=script&lang=js&"
import style0 from "./TalkSearchRecord.vue?vue&type=style&index=0&id=cdce23f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce23f0",
  null
  
)

export default component.exports